var _style, _polygon, _polygon2, _polygon3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSparklesBurst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    width: 96,
    height: 96,
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    :root { --s: var(--color-accent,#37E5FF); }\n    .star { fill: var(--s); opacity:.85; transform-origin: center; animation: pop 1.2s ease-in-out infinite; }\n    .s2 { animation-delay: .2s; opacity:.6 } .s3 { animation-delay: .4s; opacity:.5 }\n    @keyframes pop { 0%,100%{ transform: scale(.6) rotate(0) } 50%{ transform: scale(1) rotate(45deg) } }\n    @media (prefers-reduced-motion: reduce) { .star { animation: none } }\n  ")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "star",
    points: "48,8 56,40 88,48 56,56 48,88 40,56 8,48 40,40"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "star s2",
    points: "24,24 28,40 44,44 28,48 24,64 20,48 4,44 20,40"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "star s3",
    points: "72,28 76,40 88,44 76,48 72,60 68,48 56,44 68,40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparklesBurst);
export default __webpack_public_path__ + "static/media/sparkles-burst.c60d79598db68bfdec775e016a8407f2.svg";
export { ForwardRef as ReactComponent };